import {sweetAPI} from 'app/store/sweet-api';
import {showMessages} from 'app/store/sweet-api/utils';
import {TASKS_GUEST_INSTANCE_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {reformatGuestTaskURLs} from './utils/reformat-urls';

import type {TaskConcreteInstanceSerializedType} from 'sweet-types';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: ['GuestTask']})
  .injectEndpoints({
    endpoints: (build) => ({
      getGuestTaskInstance: build.query<
        TaskConcreteInstanceSerializedType,
        string
      >({
        query: (id) => `${TASKS_GUEST_INSTANCE_API_URL}${id}/`,
        transformResponse: reformatGuestTaskURLs,
      }),
      updateGuestTaskInstance: build.mutation<
        TaskConcreteInstanceSerializedType,
        {id: string}
      >({
        query: ({id, ...body}) => ({
          url: `${TASKS_GUEST_INSTANCE_API_URL}${id}/`,
          method: 'PATCH',
          body,
        }),
        transformResponse: reformatGuestTaskURLs,
        // update task cache
        onQueryStarted: (args, api) => {
          const extendedQuery = api.queryFulfilled.then(({data, meta}) => {
            api.dispatch(
              extendedAPI.util.updateQueryData(
                'getGuestTaskInstance',
                args.id.toString(),
                () => data
              )
            );
            return {data, meta};
          });
          showMessages({
            onError: () => gt('Unable to update task.'),
          })(args, {...api, queryFulfilled: extendedQuery});
        },
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {
  useQuery: useGuestTaskInstance,
  //useLazyQuery: useLazyGuestTaskInstance,
  //useQueryState: useGuestTaskInstanceState,
} = extendedAPI.endpoints.getGuestTaskInstance;

// hook to update task
export const {useMutation: useUpdateGuestTaskInstance} =
  extendedAPI.endpoints.updateGuestTaskInstance;
